import {
  Button,
  Flex,
  Image,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import logoWhite from "assets/img/layout/logoWhite.png";

export default function SidebarDocs() {
  const bgColor = "linear-gradient(135deg,rgb(56, 0, 56) 0%,rgb(172, 3, 144) 100%)";
  const borderColor = useColorModeValue("white", "navy.800");

  return (
    <Flex
      justify="center"
      direction="column"
      align="center"
      bg={bgColor}
      me={{ base: "20px" }}
      position="relative"
      className="rounded-2xl"

    >
      {/* <Flex
        border="5px solid"
        borderColor={borderColor}
        bg="linear-gradient(135deg, #868CFF 0%, #4318FF 100%)"
        borderRadius="50%"
        w="94px"
        h="94px"
        align="center"
        justify="center"
        mx="auto"
        position="absolute"
        left="50%"
        top="-47px"
        transform="translate(-50%, 0%)"
      >
        <Image src={logoWhite} w="40px" h="40px" />
      </Flex> */}
      <div
        className="pt-12 px-6 flex flex-col justify-center items-center "
      >
        <Text
          fontSize={{ base: "lg", xl: "18px" }}
          color="white"
          fontWeight="bold"
          lineHeight="150%"
          textAlign="center"
          px="10px"
          mb="14px"
        >Kamata Fursa twenzetu</Text>
        <Text
          fontSize="12px"
          color={"white"}
          px="10px"
          mb="14px"
          textAlign="center"
        >Hakimiliko yako hailiki</Text>
      </div>
      <Link href="https://bandajamii.tz">
        <Button
          bg="whiteAlpha.300"
          _hover={{ bg: "whiteAlpha.200" }}
          _active={{ bg: "whiteAlpha.100" }}
          mb={{ sm: "16px", xl: "24px" }}
          color={"white"}
          fontWeight="regular"
          fontSize="sm"
          minW="185px"
          mx="auto"
        >Wasiliana nasi</Button>
      </Link>
    </Flex>
  );
}
